// extracted by mini-css-extract-plugin
export default {"tooltip":"lP-z","arrow":"mP-z"};